// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var PharmacyCardFinderGender;
(function (PharmacyCardFinderGender) {
    PharmacyCardFinderGender["Male"] = "m";
    PharmacyCardFinderGender["Female"] = "f";
})(PharmacyCardFinderGender || (PharmacyCardFinderGender = {}));
//# sourceMappingURL=pharmacyCardFinderGender.js.map